export default "__VITE_ASSET__fAQD4oRD__"